import { Button, Flex, Form, Modal, Typography } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OpenReplacementType } from 'src/components/v2/Button/BtnHrHandle';
import { EmployeeSelect } from 'src/components/v2/Select';
import { TicketResponses } from 'src/types/elements.type';
import { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
const { Text } = Typography;

type Props = {
  employeeId?: number;
  replacerId?: number;
  departmentId?: number;
  open: OpenReplacementType;
  setOpen: Dispatch<SetStateAction<OpenReplacementType>>;
  handleAddReplacement: (
    replacerId: number,
    ticketResponses: TicketResponses[],
    approvalStatus: ApprovalStatus
  ) => void;
};

type FormStateType = {
  replacerId: number | undefined;
};

const initFormState: FormStateType = {
  replacerId: undefined
};

function AddReplacement({ employeeId, replacerId, departmentId, open, setOpen, handleAddReplacement }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [formState, setFormState] = useState({ ...initFormState, replacerId: replacerId });

  const handleSubmit = () => {
    form
      .validateFields()
      .then(() => {
        handleAddReplacement(Number(formState.replacerId), open.ticketResponses, open.approvalStatus);
        setOpen({ isOpen: false, ticketResponses: [], approvalStatus: ApprovalStatus.Reject });
        form.resetFields();
        setFormState(initFormState);
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    setOpen({ isOpen: false, ticketResponses: [], approvalStatus: ApprovalStatus.Reject });
    form.resetFields();
    setFormState(initFormState);
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Người thay thế xử lý công việc</Text>
          <Text type='danger'>*</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open.isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      styles={{ header: { marginBlockEnd: 16 } }}
      footer={[
        <Button key='back' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('action.submit')}
        </Button>
      ]}
    >
      <Form
        form={form}
        labelCol={{ span: 7 }}
        fields={[{ name: 'replacerId', value: formState.replacerId ? String(formState.replacerId) : undefined }]}
      >
        <Form.Item
          label={false}
          name='replacerId'
          rules={[
            {
              required: true,
              message: ''
            }
          ]}
        >
          <EmployeeSelect
            exclusionEmployee={employeeId}
            departmentId={departmentId}
            onChange={(value) => setFormState({ replacerId: Number(value) })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddReplacement;
